/* eslint-disable import/prefer-default-export */

export const getColumnAlignment = (column, metaField) => {
  if (column.align) return column.align;

  // Actions should be centered aligned unless otherwise specified
  if (column.action) return 'center';

  // Otherwise drive alignment off of type
  switch (metaField.attr('type')) {
    case 'number':
      return 'right';
    default:
      return 'left';
  }
};

export const setActionQueryParam = (history, actionName, args = {}) => {
  const url = new URL(window.location.href);

  const {
    metaOverrideSetName,
    resource,
    actionParamName = 'metaTableAction',
  } = args;

  if (actionName === null) {
    url.searchParams.delete(actionParamName);
  } else {
    const params = {
      actionName,
      metaOverrideSetName,
    };

    switch (actionName) {
      case 'create':
        break;
      case 'edit':
        params.url = resource.link('self').url();
        break;
      default:
        throw new Error(`Action not supported: ${actionName}`);
    }

    url.searchParams.set(actionParamName, JSON.stringify(params));
  }

  history.replace({
    pathname: url.pathname,
    search: url.search,
  });
};

export const parseActionQueryParam = (args = {}) => {
  const url = new URL(window.location.href);

  const {
    actionParamName = 'metaTableAction',
  } = args;

  const actionParam = url.searchParams.get(actionParamName);

  if (!actionParam) {
    return {};
  }

  return JSON.parse(actionParam);
};
